import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M12.4004 2C15.7603 2 17.4402 2.00042 18.7236 2.6543C19.8526 3.22954 20.7705 4.14739 21.3457 5.27637C21.9996 6.55977 22 8.23965 22 11.5996V12.4004C22 15.7603 21.9996 17.4402 21.3457 18.7236C20.7705 19.8526 19.8526 20.7705 18.7236 21.3457C17.4402 21.9996 15.7603 22 12.4004 22H11.5996C8.23965 22 6.55977 21.9996 5.27637 21.3457C4.14739 20.7705 3.22954 19.8526 2.6543 18.7236C2.00042 17.4402 2 15.7603 2 12.4004V11.5996C2 8.23965 2.00042 6.55977 2.6543 5.27637C3.22954 4.14739 4.14739 3.22954 5.27637 2.6543C6.55977 2.00042 8.23965 2 11.5996 2H12.4004Z'
            fill='currentColor'
        />
        <path d='M6 7L13 6V18H7C6.44772 18 6 17.5523 6 17V7Z' fill='white' />
        <path d='M14 10L18 9V17C18 17.5523 17.5523 18 17 18H14V10Z' fill='white' />
        <rect x='8' y='9' width='3' height='2' fill='#737390' />
        <rect x='8' y='12' width='3' height='2' fill='#737390' />
        <rect x='8' y='15' width='3' height='2' fill='#737390' />
        <rect x='14' y='12' width='3' height='2' fill='#737390' />
        <rect x='14' y='15' width='3' height='2' fill='#737390' />
    </svg>
);

export const CompanyIcon = styled(Icon)({});
